import React from "react";
import { withTranslation } from "react-i18next";
import { 
  Paper, 
  Grid, 
  Typography, 
  makeStyles, 
  Divider 
} from "@material-ui/core";
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "3vh 3vw",
  },
  title: {
    ...theme.typography.subtitle2,
    textAlign: "center"
  },
  subtitle:{
    ...theme.typography.subtitle1,
    color: theme.palette.primary.dark
  },
  spacer: {
    marginBottom: 20
  },
}));

const Summary = ({ t, committeeSummary, dayOfWeekName, quorum }) => {
  const classes = useStyles();
  
  return (
    <Paper elevation={1} className={clsx(classes.root)}>
      <Typography className={clsx(classes.spacer, classes.title)}>
        {t("forms.committee.infoCommittee")}
      </Typography>
      <Divider className={classes.spacer} />
      <Typography className={classes.subtitle}>
        {t("forms.committee.chairperson")}
      </Typography>
      <Typography variant="subtitle1">
        {committeeSummary.chairPerson}
      </Typography>
      <Typography className={classes.subtitle}>
      {t("forms.committee.coChair")}
      </Typography>
      <Typography variant="subtitle1">
        {committeeSummary.cochair}
      </Typography>
      <Typography className={classes.subtitle}>
        {t("forms.committee.secretary")}
      </Typography>
      <Typography variant="subtitle1">
        {committeeSummary.secretary}
      </Typography>
      <Typography className={classes.subtitle}>
        {t("forms.committee.daysOfWeek.title")}
      </Typography>
      <Typography variant="subtitle1" className={classes.spacer}>
        { dayOfWeekName }
      </Typography>
      <Typography className={clsx(classes.spacer, classes.title)}>
        {t("forms.committee.quorum.title")}
      </Typography>
      <Divider className={classes.spacer} />
      <Grid container item direction="row" className={classes.spacer}>
        <Grid container item direction="column" alignItems="center" lg={6} >
          <Grid item>
            <Typography variant="subtitle1">
              { quorum.instalers }
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.subtitle}>
              {t("forms.committee.installation")}
            </Typography>
          </Grid>
        </Grid>
        <Grid container item direction="column" alignItems="center" lg={6}>
          <Grid item>
            <Typography variant="subtitle1">
              { quorum.approvers }
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.subtitle} >
            {t("forms.committee.approval")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Typography className={clsx(classes.spacer, classes.title)}>
        {t("forms.committee.membersVote.title")}
      </Typography>
      <Divider className={classes.spacer} />
      {
        committeeSummary.membersRightToVote.map((member, index) => (
          <Typography variant="subtitle1" key={member.id} 
            className={clsx(index+1 == committeeSummary.membersRightToVote.length ? classes.spacer : "")}>
            {member.name}
          </Typography>
        ))
      }
      <Typography className={clsx(classes.spacer, classes.title)}>
        {t("forms.committee.members.title")}
      </Typography>
      <Divider className={classes.spacer} />
      {
        committeeSummary.membersNotRightToVote.map((member, index) => (
          <Typography variant="subtitle1" key={member.id} 
            className={clsx(index+1 == committeeSummary.membersNotRightToVote.length ? classes.spacer : "")}>
            {member.name}
          </Typography>
        ))
      }
    </Paper>
  );
};

export default withTranslation()(Summary);
